import AFN from './AFN';
import AMD from './AMD';
import AZN from './AZN';
import BDT from './BDT';
import BND from './BND';
import BTN from './BTN';
import CNY from './CNY';
import HKD from './HKD';
import IDR from './IDR';
import INR from './INR';
import IQD from './IQD';
import IRR from './IRR';
import JPY from './JPY';
import KGS from './KGS';
import KHR from './KHR';
import KPW from './KPW';
import KRW from './KRW';
import KZT from './KZT';
import LAK from './LAK';
import LKR from './LKR';
import MMK from './MMK';
import MOP from './MOP';
import MVR from './MVR';
import MYR from './MYR';
import NPR from './NPR';
import PHP from './PHP';
import PKR from './PKR';
import SGD from './SGD';
import SYP from './SYP';
import THB from './THB';
import TJS from './TJS';
import TMT from './TMT';
import TRY from './TRY';
import TWD from './TWD';
import UZS from './UZS';
import VND from './VND';

export const ASIA_CURRENCIES = {
    [AFN.codeNumeric]: AFN,
    [AMD.codeNumeric]: AMD,
    [AZN.codeNumeric]: AZN,
    [BDT.codeNumeric]: BDT,
    [BND.codeNumeric]: BND,
    [BTN.codeNumeric]: BTN,
    [CNY.codeNumeric]: CNY,
    [HKD.codeNumeric]: HKD,
    [IDR.codeNumeric]: IDR,
    [INR.codeNumeric]: INR,
    [IQD.codeNumeric]: IQD,
    [IRR.codeNumeric]: IRR,
    [JPY.codeNumeric]: JPY,
    [KGS.codeNumeric]: KGS,
    [KHR.codeNumeric]: KHR,
    [KPW.codeNumeric]: KPW,
    [KRW.codeNumeric]: KRW,
    [KZT.codeNumeric]: KZT,
    [LAK.codeNumeric]: LAK,
    [LKR.codeNumeric]: LKR,
    [MMK.codeNumeric]: MMK,
    [MOP.codeNumeric]: MOP,
    [MVR.codeNumeric]: MVR,
    [MYR.codeNumeric]: MYR,
    [NPR.codeNumeric]: NPR,
    [PHP.codeNumeric]: PHP,
    [PKR.codeNumeric]: PKR,
    [SGD.codeNumeric]: SGD,
    [SYP.codeNumeric]: SYP,
    [THB.codeNumeric]: THB,
    [TJS.codeNumeric]: TJS,
    [TMT.codeNumeric]: TMT,
    [TRY.codeNumeric]: TRY,
    [TWD.codeNumeric]: TWD,
    [UZS.codeNumeric]: UZS,
    [VND.codeNumeric]: VND
};
